// extracted by mini-css-extract-plugin
export default {"Container":"FeedbackActionModal__Container__fNx6F","ActionsWrapper":"FeedbackActionModal__ActionsWrapper__1L145"};